module.exports = __webpack_public_path__ + "static/media/keyFeature2.3ade5c5b.png";